'use strict';

var Bacon, Dispatcher, Fuse, R, ServiceTypes, T, allCategories, allFilteredItems, allItems, allMenus, byPriority, categoriesProperty, categoriesWOCoupons, categoryItems, couponStream, currentMenu, currentRestaurant, d, defaultMenu, disableMenuFiltering, extractItems, filterOrderDate, filterServiceType, filterStream, filteredCategories, filteredCouponItems, filteredItems, filteredMenus, filteredMenusOrAll, filters, hasCoupons, hasCoupons2, itemCount, itemHasCoupon, loading, makeSearchKey, menuCategories, menusGQL, menusProperty, noCoupon, nonCouponsWithCodeItems, normalizeItem, onlyNonEmpty, portalStore, resUtil, resetFilters, restaurantStore, saveProp, searchCoupons, searchItems, searchMenus, searchOptions, searchOptionsWithScore;

Bacon = require('baconjs');

R = require('ramda');

resUtil = require('../utils/resources');

restaurantStore = require('./restaurant');

portalStore = require('./portal');

// Fuzzy = require 'fuzzy'
Fuse = require('fuse.js');

Dispatcher = require('../utils/dispatcher');

d = new Dispatcher('menu');

T = require('../utils/translation');

filterStream = new Bacon.Bus();

couponStream = new Bacon.Bus();

currentRestaurant = restaurantStore.restaurant.skipDuplicates(R.equals);

// cartSettingsStore = require './cart/settings'
menusGQL = require('./menu-gql');

// searchOptions =
//   pre: ''
//   post: ''
//   extract: (item) ->
//     item.name + " " + item.description
searchOptions = {
  include: [],
  // includeScore: true
  shouldSort: true,
  tokenize: true,
  matchAllTokens: true,
  // threshold: 0.4
  // location: 0
  // distance: 10
  maxPatternLength: 32,
  minMatchCharLength: 1,
  keys: ['searchKey']
};

searchOptionsWithScore = {
  shouldSort: true,
  includeScore: true,
  threshold: 0.6,
  location: 0,
  distance: 100,
  maxPatternLength: 32,
  minMatchCharLength: 1,
  // keys: ["name", "description", "category.name"]
  keys: ['searchKey']
};

makeSearchKey = function makeSearchKey(item) {
  return R.assoc('searchKey', R.join(" ", [item.category.name, item.name, item.description]), item);
};

nonCouponsWithCodeItems = R.map(R.filter(R.pipe(R.prop("couponCode"), R.defaultTo(""), R.trim, R.length, R.equals(0))));

byPriority = R.prop('priority');

categoryItems = function categoryItems(sum, item) {
  return R.append(item, sum);
};

// sum ++ Category -> Sorted [ Items ]
menuCategories = function menuCategories(sum, category) {
  return R.append(R.reduce(categoryItems, [], R.map(R.merge({
    category: category,
    menu: category.menu
  }), R.sortBy(byPriority, category.items))), sum);
};

// sum ++ Menu -> Sorted [ Category ]
// extractItems = [ [ Item ] ] -> Menu -> [ [ Item ] ]
// extract all items from all all categories and returns an array of arrays of items sorted
extractItems = function extractItems(sum, menu) {
  return R.reduce(menuCategories, sum, R.map(R.assoc('menu', menu), R.sortBy(byPriority, menu.categories)));
};

searchItems = R.curry(function (query, items) {
  var fuse;
  if (query && query.length) {
    fuse = new Fuse(R.map(makeSearchKey, items), searchOptions);
    return fuse.search(query);
  } else {
    return items;
  }
});

searchCoupons = R.curry(function (coupon, items) {
  if (coupon && coupon.length) {
    return R.filter(R.propEq('couponCode', coupon.toLowerCase()), items);
  } else {
    return R.filter(R.propEq('couponCode', null), items);
  }
});

searchMenus = R.curry(function (menu, items) {
  if (menu) {
    return R.filter(R.propEq('menu', menu), items);
  } else {
    return items;
  }
});

filterOrderDate = R.curry(function (orderDate, menu) {
  var close, day, days, min, open, time;
  if (!menu.availability.custom) {
    return true;
  }
  if (!orderDate) {
    return true;
  }
  var _menu$availability = menu.availability;
  time = _menu$availability.time;
  days = _menu$availability.days;

  day = orderDate.getDay() % 7;
  if (time[day]) {
    var _time$day = time[day];
    open = _time$day.open;
    close = _time$day.close;

    min = orderDate.getHours() * 60 + orderDate.getMinutes();
    if (min < 4 * 60) {
      min += 24 * 60;
    }
    return (days & Math.pow(2, day)) !== 0 && open <= min && min < close;
  } else {
    return false;
  }
});

ServiceTypes = ['DELIVERY', 'PICKUP', 'DINEIN', 'CURBSIDE'];

filterServiceType = R.curry(function (serviceType, menu) {
  var index;
  if (!menu.availability.custom) {
    return true;
  }
  if (!serviceType) {
    return true;
  }
  index = R.findIndex(R.equals(serviceType), ServiceTypes);
  if (index >= 0) {
    return (menu.availability.services & Math.pow(2, index)) !== 0;
  } else {
    return true;
  }
});

allMenus = menusGQL.flatMap(T.translateGQLMenu);

defaultMenu = allMenus.map(function (menus) {
  return R.find(R.propEq('default', true), menus) || R.nth(0, menus);
});

loading = currentRestaurant.awaiting(allMenus);

// Has a list of categories of items. Each item has a refecence to
// the menu and the category that belongs to
// [ Category [ Items {Menu, Category} ] ]
allCategories = allMenus.map(R.reduce(extractItems, []));

// [ Item {Menu, Category} ]
allItems = allCategories.map(R.flatten).toProperty();

allItems.onValue(function (value) {});

// console.log "Store All Items", value
onlyNonEmpty = R.filter(R.compose(R.lt(0), R.length));

categoriesProperty = Bacon.update([], [currentRestaurant.changes()], function () {
  return [];
}, [allCategories.toEventStream()], function (_, categories) {
  return categories;
});

categoriesWOCoupons = categoriesProperty.map(function (categories) {
  return nonCouponsWithCodeItems(categories);
});

itemCount = function itemCount(items) {
  return R.sum(R.map(R.length, items));
};

hasCoupons = categoriesProperty.combine(categoriesWOCoupons, function (categories, filteredCategories) {
  return itemCount(categories) > itemCount(filteredCategories);
});

saveProp = R.curry(function (prop, prev, value) {
  return R.assoc(prop, value, prev);
});

resetFilters = function resetFilters(prev, _) {
  return {
    coupon: null,
    query: null,
    menu: null,
    serviceType: null,
    orderDate: null
  };
};

filters = Bacon.update({
  coupon: null,
  query: null,
  menu: null,
  orderDate: null,
  serviceType: null
}, [currentRestaurant.changes()], resetFilters, [couponStream.throttle(500)], saveProp('coupon'), [filterStream.throttle(500)], saveProp('query'), [d.stream('current-menu')], saveProp('menu'), [d.stream('filter-order-date')], saveProp('orderDate'), [d.stream('filter-service-type')], saveProp('serviceType'));

d.stream('current-menu').plug(defaultMenu);

filteredCategories = categoriesProperty.combine(filters, function (categories, filters) {
  return onlyNonEmpty(R.map(R.pipe(searchMenus(filters.menu), searchCoupons(filters.coupon), searchItems(filters.query)), categories));
});

// TODO: Filter menus as well for web4
menusProperty = Bacon.update({
  menus: [],
  current: null
}, [currentRestaurant.changes()], function () {
  return {
    current: null,
    menus: []
  };
}, [allMenus.toEventStream()], function (_ref, menus) {
  var current = _ref.current;

  return {
    current: current,
    menus: menus
  };
}, [d.stream('current-menu')], function (_ref2, current) {
  var menus = _ref2.menus;

  return { current: current, menus: menus };
});

menusProperty.onValue(function () {}); // Retain menus all the time....

filteredMenus = menusProperty.combine(filters, function (data, filters) {
  return R.filter(R.allPass([filterOrderDate(filters.orderDate), filterServiceType(filters.serviceType)]), data.menus);
}).toProperty();

filteredMenusOrAll = filteredMenus.combine(allMenus, function (filtered, all) {
  if (filtered.length) {
    return filtered;
  } else {
    return all;
  }
}).toProperty();

allFilteredItems = filteredMenus.map(R.reduce(extractItems, [])).map(R.flatten).toProperty();

itemHasCoupon = R.where({
  couponCode: R.compose(R.not, R.isEmpty, R.defaultTo('')),
  coupon: R.equals(true)
});

hasCoupons2 = allFilteredItems.map(R.any(itemHasCoupon)).toProperty();

normalizeItem = function normalizeItem(searchItem) {
  return R.assoc('score', searchItem.score, searchItem.item);
};

noCoupon = R.where({
  coupon: R.equals(false)
});

filteredItems = allFilteredItems.map(function (items) {
  return new Fuse(R.map(makeSearchKey, items), searchOptionsWithScore);
}).combine(filters, function (fuse, filters) {
  if (filters.query && filters.query.length > 2) {
    return fuse.search(filters.query);
  } else {
    return [];
  }
}).map(R.map(normalizeItem)).map(R.filter(R.pipe(R.prop('score'), R.lt(R.__, 0.50)))).map(R.filter(noCoupon));

filteredCouponItems = allFilteredItems.combine(filters, function (items, filters) {
  var acceptsCoupon;
  if (filters.coupon && filters.coupon.length) {
    acceptsCoupon = R.where({
      couponCode: R.compose(R.equals(filters.coupon.toLowerCase()), R.toLower, R.defaultTo('')),
      coupon: R.equals(true)
    });
    return R.filter(acceptsCoupon, items);
  } else {
    return [];
  }
});

disableMenuFiltering = d.stream('disable-menu-filtering').toProperty(false);

disableMenuFiltering.onValue(function () {});

// TODO API5: Send these instead of subscribe
// serviceTypeStream = cartSettingsStore
//   .orderType
//   .selected
//   .map(R.prop('id'))
//   .changes()
//   .skipDuplicates(R.equals)
//   .skipWhile(disableMenuFiltering)

// d.stream('filter-service-type').plug serviceTypeStream

// orderTimeStream = cartSettingsStore
//   .orderTime
//   .value
//   .changes()
//   .skipDuplicates(R.equals)
//   .skipWhile(disableMenuFiltering)

// d.stream('filter-order-date').plug orderTimeStream
currentMenu = menusProperty.map(R.prop('current')).combine(filteredMenusOrAll, function (current, filtered) {
  if (R.contains(current, filtered)) {
    return current;
  } else {
    return R.head(filtered);
  }
});

filteredMenusOrAll.onValue(function () {});

module.exports = {
  loading: loading,
  // All menus - not filtered
  menus: filteredMenusOrAll,
  currentMenu: currentMenu,
  setCurrentMenu: function setCurrentMenu(menu) {
    return d.stream('current-menu').push(menu);
  },
  disableMenuFiltering: function disableMenuFiltering() {
    d.stream('filter-order-date').push(null);
    d.stream('filter-service-type').push(null);
    return d.stream('disable-menu-filtering').push(true);
  },
  // [ Category [ Item ] ]
  // categories: categoriesProperty.map R.prop 'filteredCategories'
  // SET CURRENT MENU FOR THIS TO WORK
  categories: filteredCategories.toProperty(),
  // Used for item search
  filter: filterStream,
  // Used for category filtering
  coupon: couponStream,
  // Some categories have copupons items
  hasCoupons: hasCoupons2,
  // setServiceFilter: d.stream('filter-service-type').push
  // setOrderDateFilter: d.stream('filter-order-date').push

  // All items
  allItems: allItems,
  filteredItems: filteredItems,
  filteredCouponItems: filteredCouponItems
};